import React, { useEffect } from "react";

import useState from "react-usestateref";

// import Pagination from "react-js-pagination";
import apiService from "../core/service/detail";
import { getMethod } from "../core/service/common.api";
import Pagination from "@material-ui/lab/Pagination";
import { Typography } from "@material-ui/core";
import useStyles from "../components/Header/styles";
import { postMethod } from "../core/service/common.api";
import moment from "moment";

function BlocksentialContact() {
  const [currentPage, setCurrentPage] = useState(1);
  const [getP2POrders, setgetAllp2pOrders, getP2POrdersref] = useState([]);
  const [totalPage, setTotalpages] = useState(0);
  var classes = useStyles();
  const recordPerPage = 10;
  // total number of the records
  const totalRecords = 15;
  // range of pages in paginator
  const pageRange = 5;

  const handlePageChange = (pageNumber) => {
    getContacts(pageNumber);
    setCurrentPage(pageNumber);
    // setchoosepage()
  };

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async (page) => {
    try {
      var payload = {
        perpage: 10,
        page: page,
        search: "btc",
      };
      var data = {
        apiUrl: apiService.getBlocksentialscontacts,
        payload: payload,
      };
      console.log(data);
      var resp = await postMethod(data);

      if (resp.status) {
        console.log(resp.data.data, "resp.data.data");
        setgetAllp2pOrders(resp.data.data);
        setTotalpages(resp.data.pages);
      }
    } catch (error) {}
  };

  const enquiry = async (e) => {
    try {
      var payload = {
        _id: e._id,
        status: "read",
      };
      var data = {
        apiUrl: apiService.changestatus,
        payload: payload,
      };

      var resp = await postMethod(data);
      if (resp.status) {
        getContacts();
      } else {
      }
    } catch (error) {
      console.log("=-=-=-=-=-=-=-=-", error, "=-=-=-=-=-error-=-=");
    }
  };

  return (
    <div>
      <Typography
        fullWidth
        color="inherit"
        className={classes.blog_categories}
        variant="body2"
        sx={{ mt: 1 }}
      >
        Block sentinels Contact
      </Typography>
      <table class="table table-striped">
        <thead>
          <tr>
            <th> S.No</th>
            <th> Name </th>
            <th> Email</th>
            <th> Mobile Number</th>
            <th> Country</th>
            <th> Message </th>
            <th> recivedDate </th>
            <th> Status </th>
          </tr>
        </thead>

        <tbody>
          {
          getP2POrdersref.current.length>0 ?getP2POrdersref.current &&
            getP2POrdersref.current.map((orders, i) => {
              return (
                <tr>
                  <td>{i + 1}</td>
                  <td>{orders.userName}</td>
                  <td>{orders.email}</td>
                  <td>{orders.mobileNumber}</td>
                  <td>{orders.country}</td>
                  <td>{(orders.comments).substring(0,15)}...</td>

                  <td>{moment(orders.createdAt).format("lll")}</td>

                  <td>
                    {orders.readStatus == "notread" ? (
                      <p
                        style={{ color: "green" }}
                        onClick={() => enquiry(orders)}
                      >
                        {" "}
                        Open{" "}
                      </p>
                    ) : (
                      <p style={{ color: "red" }}> Closed </p>
                    )}
                  </td>
                </tr>
              );
            }):<tr className="no-record">
                        <td colSpan={8}>
                          <div className="emptyrecordimg">
                              <img
                                        src={require("../images/No-data.webp")}
                                        width="100px"
                                      />
                          <span className="emptyrecord">No records found</span>
                          </div>
                        </td>
                      </tr>}
        </tbody>
      </table>
      {/* <Pagination
        itemClass="page-item" // add it for bootstrap 4
        linkClass="page-link" // add it for bootstrap 4
        activePage={currentPage}
        itemsCountPerPage={recordPerPage}
        totalItemsCount={totalPage}
        pageRangeDisplayed={pageRange}
        onChange={handlePageChange}
      /> */}
      <Pagination
        count={totalPage}
        page={currentPage}
        onChange={(e, value) => handlePageChange(value)}
        className={classes.blog_pagination}
        color="primary"
        shape="rounded"
      />
    </div>
  );
}

export default BlocksentialContact;
